import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../auth/components/PasswordRecoveryModal";

import DangerBaseButton from "./DangerBaseButton";

export function SuccessModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
  title: string;
  contentText: string;
}) {
  const { open, setOpen } = props;

  const onClose = () => {
    setOpen(false);
    props.onClose && props.onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        {props.title}
      </DialogHeader>
      <DialogContent
        sx={{
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom>{props.contentText}</Typography>
      </DialogContent>
      <DialogActions>
        <DangerBaseButton
          variant="contained"
          onClick={onClose}
          title="Fechar"
        />
      </DialogActions>
    </Dialog>
  );
}
